/*
  "Was this click inside a modal stacked over `host`?" — for the handlers that close an inline
  editor on a click outside it (FTSTableEdit deselecting its row, FTSInlineEdit blurring its cell).

  A modal the editor opened (FTSFile's image lightbox, a dialog) is moved to <body> by FTSModal's
  append-to-body, so `host.contains(target)` is false for every click inside it. Treating those as
  outside clicks closes the editor, and closing the editor destroys the modal it opened: the
  lightbox of a signature in a selected table row vanished on its first click (download, expand,
  next image). A modal that CONTAINS host is not stacked over it — the quick view or form a table
  sits in — so a click elsewhere in that modal still counts as outside.

  `closest` also covers a target its own click already detached (the lightbox's X removes the
  lightbox before the click reaches document): the detached subtree keeps its ancestors.
*/
const inModalOver = (target, host) => {
  const modal = target && target.closest ? target.closest(".fts-modal") : null;
  return Boolean(modal && host && !modal.contains(host));
};

export default inModalOver;
export { inModalOver };
